import { format, parse, getDate, addMonths, setDate, intervalToDuration, formatDuration } from 'date-fns';
import { nl } from 'date-fns/locale'

/*export function getDate(date?: string) {
    const today = date ? new Date(date) : new Date();
    return `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
}*/

export function convertDateString(date: string, formatString = 'dd-MM-yyyy', exportFormatString = 'yyyy-MM-dd') {
	return format(parse(date, formatString, new Date()), exportFormatString);
}

export function parseDate(date: string): Date {
	return parse(date, 'yyyy-MM-dd', new Date());
}

export function convertDateObject(date: Date, displayFormat?: boolean) {
	return format(date, (displayFormat) ? 'dd-MM-yyyy' : 'yyyy-MM-dd');
}

export function convertToFirstOfTheNextMonth(dateString: string): Date {
	let date = parseDate(dateString);
	if (getDate(date) > 1) {
		// add one month & set to first of the month
		return setDate(addMonths(date, 1) ,1);
	}

	return date;
}

export function getFormattedDuration(months: number) {
	if (months) {
		return formatDuration(intervalToDuration({
			start: new Date(),
			end: addMonths(new Date(), months)
		}), { locale: nl, format: ['years', 'months']})
	}
}

//getDate(date)
